import React, { Component } from 'react';

class Footer extends Component {

	render() {
		return(
			<footer className="py-5 bg-black">
          <div className="container">
            <p className="m-0 text-center text-white small">
              The website and trained algorithm is Copyright &copy; <a href="http://www.aboriginal-armadillo.com">Aboriginal Armadillo LLC, 2020</a>.<br />
              Star Trek and related marks are trademarks of CBS Studios Inc.
							Star Trek was created by Gene Roddenbury.
							Star Trek and all related marks, logos and characters are solely owned by CBS Studios Inc. This fan production is not endorsed by, sponsored by, nor affiliated with CBS, Paramount Pictures, or any other Star Trek franchise, and is a non-commercial fan-made film intended for recreational use. No commercial exhibition or distribution is permitted. No alleged independent rights will be asserted against CBS or Paramount Pictures
					</p>
          </div>

        </footer>
		)
	}
}

export default Footer;